import {User} from './user';

export enum ProtectionType {
    GUEST = 'GUEST',
    IDENTIFICATION = 'IDENTIFICATION',
    PASSWORD = 'PASSWORD',
    REGISTERED_USERS = 'REGISTERED_USERS',
    SELECTED_USERS = 'SELECTED_USERS',
    AAI_EDU = 'AAI_EDU',
    ZOOM = 'ZOOM',
    EMEDIKUS = 'EMEDIKUS',
}

export type ProtectionInfo = {
    _id?: string;
    types: ProtectionType[];
    identificationLabel?: string;
    password?: string;
    validUntil?: string;
    allowedIds?: string[];
    allowedUsers?: Pick<User, '_id' | 'email'>[];
};
